import { showPublicActivitiesAtom } from "@/state/filters.state";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function PublicActivitiesLayout() {
  const setShowPublicActivities = useSetAtom(showPublicActivitiesAtom);

  useEffect(() => {
    setShowPublicActivities(true);
    return () => setShowPublicActivities(undefined);
  }, [setShowPublicActivities]);

  return <Outlet />;
}
